import { Navigate } from 'react-router-dom'
import SidebarToggle from '@/components/SidebarToggle'
import {
  GOOGLE_CALENDAR_ENABLED,
  MEETING_BRIEF_ENABLED,
  UPCOMING_MEETINGS_ENABLED,
} from '@/constants/feature-flags'
import { useUiStrings } from '@/hooks/useUiStrings'
import UpcomingCalendar from '@/pages/Home/components/UpcomingCalendar'

/** Read-only calendar listing; /history remains the BrSE recording library. */
export default function UpcomingPage() {
  const { t } = useUiStrings()
  if (!UPCOMING_MEETINGS_ENABLED) return <Navigate to="/home" replace />

  return (
    <>
      <header className="flex h-14 shrink-0 items-center gap-3 border-b border-[var(--border-color)] bg-[var(--bg-secondary)] px-4 sm:px-6">
        <SidebarToggle />
        <h1 className="min-w-0 flex-1 truncate text-lg font-bold">{t.upcomingSectionTitle}</h1>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6 sm:py-6">
        <UpcomingCalendar
          variant="full"
          provider="microsoft"
          withBrief={MEETING_BRIEF_ENABLED}
        />
        {/* The spacer belongs to the panel, not to the page: left behind on its own it would
            put 40px of nothing under the Teams table. */}
        {GOOGLE_CALENDAR_ENABLED && (
          <div className="mt-10">
            <UpcomingCalendar
              variant="full"
              provider="google"
              withBrief={MEETING_BRIEF_ENABLED}
            />
          </div>
        )}
      </div>
    </>
  )
}
